import { Api } from 'utils';

class ClientService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/clients/get',params),
		create: async (params?: any) => Api.createResponse('admin/clients/create',params),
		validateCreate: async (params?: any) => Api.createResponse('admin/clients/validate-create',params),
		update: async (params?: any) => Api.createResponse('admin/clients/update',params),
		delete: async (params?: any) => Api.createResponse('admin/clients/delete',params),
		bulkDelete: async (params?: any) => Api.createResponse('admin/clients/bulk-delete',params),
		download: async (params?: any) => Api.createResponse('admin/clients/download',params),
	}

}

export default ClientService;